import React, { Component } from 'react';
import PropTypes from 'prop-types';

import { Field, FieldArray, reduxForm, formValueSelector } from 'redux-form';
import { connect } from 'react-redux';
import submit from './submit';
import validate from './validate';

// Style
import cx from 'classnames';
import { Button } from 'react-bootstrap';
import withStyles from 'isomorphic-style-loader/withStyles';
import Uploader from './Uploader/Uploader';

// Translation
import { FormattedMessage, injectIntl } from 'react-intl';
import { url } from '../../../config';
import messages from '../../../locale/jsonMessages';
import CommonFormComponent from '../../CommonField/CommonFormComponent';
import FieldArrayComponent from '../../CommonFields/FieldArrayComponent';
import { AddIcon, DeleteIcon } from '../../Common/Assets/SvgIconComponent/CommonSvgIcon';
import { formatLocaleData } from '../../../helpers/formatLocale';

import cs from '../../../components/commonStyle.css';
import s from './FindYourVehicleForm.css';

class FindYourVehicleForm extends Component {

  static propTypes = {
    initialValues: PropTypes.object,
    title: PropTypes.string.isRequired,
  };

  constructor(props) {
    super(props);
    this.state = {
      contentCount: 3
    };
  }

  componentDidMount() {
    this.setContentCount(this.props.initialValues);
  }

  UNSAFE_componentWillReceiveProps(nextProps) {
    if (nextProps.initialValues !== this.props.initialValues) {
      this.setContentCount(nextProps.initialValues);
    }
  }

  setContentCount = (initialValues) => {
    const dynamicData = initialValues?.dynamicFindYourVehicleBlock || [];
    const hasContent5 = dynamicData.some(item => item?.content5);
    const hasContent4 = dynamicData.some(item => item?.content4);

    this.setState({
      contentCount: hasContent5 ? 5 : hasContent4 ? 4 : 3
    });
  }

  handleAddMore = () => {
    const { contentCount } = this.state;
    if (contentCount < 5) {
      this.setState({ contentCount: contentCount + 1 });
    }
  }

  handleRemove = async () => {
    const { change, selectedLanguage } = this.props;
    const { contentCount } = this.state;
    const fieldName = `content${contentCount}`;

    if (contentCount > 3) {
      selectedLanguage?.map((item, index) => change(`dynamicFindYourVehicleBlock[${index}].${fieldName}`, null));
      this.setState({ contentCount: contentCount - 1 });
    }
  }

  render() {

    const { error, handleSubmit, submitting, selectedLanguage } = this.props;
    const { formatMessage } = this.props.intl;
    const { contentCount } = this.state;
    let activeFields = ['language', 'heading', 'buttonLabel', 'content1', 'content2', 'content3'];
    contentCount >= 4 && activeFields.push('content4');
    contentCount >= 5 && activeFields.push('content5');

    return (
      <div>
        <h1 className='siteAdminHeading'><FormattedMessage  {...messages.findYourCar} /></h1>
        <form onSubmit={handleSubmit(submit)}>
          {error && <strong>{formatMessage(error)}</strong>}
          <div className={'oneColumnGrid'}>
            <div className='siteAdminDropZoneWrapper siteAdminCenterContainer'>
              <label className={cx('commonLabelText', cs.spaceBottom3)} ><FormattedMessage  {...messages.imageLabel} /></label>
              <Uploader />
            </div>
            <div className="twoColumnGrid">
              <Field
                name="buttonLink"
                component={CommonFormComponent}
                isAddon={true}
                suffixLabel={`${url}/`}
                addonContainerClass={'addonMobileWrapper'}
                labelText={formatMessage(messages.buttonLink)}
                placeholder={formatMessage(messages.buttonLink)}
                isRequiredInput
              />
            </div>
            <div className='siteAdminCenterContainerBox'>
              <FieldArray
                name="dynamicFindYourVehicleBlock"
                component={FieldArrayComponent}
                activesFields={activeFields}
                filedName={"dynamicFindYourVehicleBlock"}
                selectedLanguage={selectedLanguage}
                isDouble
              />
              <div className={cx(cs.spaceTop4, 'doubleBtnFlexEnd')}>
                {contentCount > 3 &&
                  <Button className={cx(cs.linkBtnPrimaryStyle, s.removeColor, 'iconButtonFlex')}
                    type="button" disabled={submitting} onClick={this.handleRemove}>
                    <DeleteIcon />
                    <FormattedMessage  {...messages.remove} />
                  </Button>}
                {contentCount < 5 &&
                  <Button className={cx(cs.linkBtnPrimaryStyle, 'iconButtonFlex')}
                    type="button" disabled={submitting} onClick={this.handleAddMore}>
                    <AddIcon />
                    <FormattedMessage  {...messages.addLabel} />
                  </Button>}
              </div>
            </div>
          </div>
          <div className={cx(cs.spaceTop4, 'singleBtnFlexEnd')}>
            <Button className={cx(cs.btnPrimary)} type="submit" disabled={submitting}>
              <FormattedMessage  {...messages.save} />
            </Button>
          </div>
        </form>
      </div>
    );
  }

}

FindYourVehicleForm = reduxForm({
  form: 'FindYourVehicleForm', // a unique name for this form
  validate
})(FindYourVehicleForm);

const selector = formValueSelector('FindYourVehicleForm');

const mapState = (state) => ({
  selectedLanguage: selector(state, 'dynamicFindYourVehicleBlock'),
  activeLanguageCodes: state.runtime.isActiveLanguages.map(item => formatLocaleData(item))
});

export default injectIntl(withStyles(cs, s)(connect(mapState)(FindYourVehicleForm)));
